const Utils = require('./utils.js');

const DEFAULTS = {
  color: "#41a277",
  width: 1200,
  height: 800
};

class Interface {
  constructor (options = {}) {
    let settings = Object.assign(DEFAULTS,options);
    this.width = settings.width;
    this.height = settings.height;
    this.color = settings.color;
    this.council = false;
    this.unselectedColor = "black";
    this.instructions = false;
    this.game = settings.game;
    this.stage = "beginning";
    this.messages = ["Welcome, my liege. Your first task as our new leader is "+
    "to pick a country on which to establish a base. Countries begin as the " +
    "the same size, but through war we can gain territory. The color (from white," +
    " to blue, to green, to orange) reflects the climate, coldest to hottest. We can "+
    "only guess how much of the land is actually usable.", "Also, before I "+
    "forget, you shouldn't be too quick to pick the greenest pastures. "+
    "Victory is measured not by mere survival, but by thriving in your " +
    "environment. With harsh conditions, our people will become stronger than "+
    "they would in an environment where nothing is testing for desirable "+
    "traits. Those with negative traits will be just as likely to multiply "+
    "as those fortunate in the genetic lottery. While our short-term "+
    "prospects of survival in a harsh climate will be challenged, I have no "+
    "doubt that the brave will eventually be rewarded for their endurance.",
    "I originally had planned to spend 3 days on this game. It was not meant "+
    "to be anything more than a quick demonstration of animating through "+
    "JavaScript. Hell, the original vision for this game was not even meant "+
    "to be interactive, but instead a visual representation of the underlying "+
    "algorithm. I got caught up with wanting to add 'just one more feature' "+
    "until eventually I produced what you have just finished (which, by the "+
    "way, it really means a lot to me that you did).","Ultimately, I learned "+
    "a lesson in the importance of delivering a finished product; 'a finished "+
    "stick man is better than an unfinished Mona Lisa' and all that. Anyway, "+
    "thank you again for giving my game a shot."
  ];
    this.milText = ["Train soldiers","Fortify defenses", "Train militia", "Increase funding"];
    this.domText = ["Encourage \"multiplication\"","Develop land", "Increase production", "Increase education"];
    this.techText = ["Military research", "Domestic research", "Shady research", "Increase funding"];
    this.shadyText = ["Kidnap Princess","Frame enemy King", "Send Trojan Cube", "Spread propaganda"];
    this.selected = "";
  }

  giveInstructions () {
    this.instructions = true;
    this.stage = "instructions";
  }

  setMessage (msg) {
    this.message = msg;
  }

  setMilText (array) {
    this.milText = array;
  }

  setDomText (array) {
    this.domText = array;
  }

  bringUpCouncil () {
    this.council = true;
  }

  endGame () {
    this.stage = "endGame";
  }

  loseGame () {

  }
  
  goBetweenAges () {
    this.stage = "betweenAges";
    this.selected = "";
    this.council = false;
    this.unselectedColor = this.game.modIsReady ? "black" : "grey";
  }

  setTechText (array) {
    this.techText = array;
  }

  setShadyText (array) {
    this.shadyText = array;
  }

  resumeGame () {
    this.stage = "resumeGame";
    this.unselectedColor = "grey";
  }

  setSelected (text) {
    if (text !== "ignore") {
      this.selected = text;
    }
  }

  startGame () {
    this.stage = "pickCountry";
  }

  checkFunc() {
    return this.message;
  }

  draw (ctx) {
    // Sidebar
    ctx.beginPath();
    ctx.rect(this.width * 0.70, this.height / 10 + 2, this.width * 0.30, this.height * 0.9 - 2);
    ctx.fillStyle = "#a4f1eb";
    ctx.lineWidth = 5;
    ctx.strokeStyle = 'black';
    ctx.stroke();
    ctx.fill();

    if (this.stage === "beginning") {
      ctx.font = `${this.height * 0.008 + 3}pt helvetica`;
      ctx.textAlign = 'center';
      ctx.fillStyle = 'black';
      ctx.fillText("Shapes of War - Designed and coded by Robert Taussig.", this.width * 0.85 + 3,this.height * 0.95);
      ctx.fillText("I sincerely hope you enjoy the game.", this.width * 0.85 + 3,this.height * 0.975);
    } else if (this.stage === "instructions") {
      ctx.font = `${this.height * 0.0125 + 3}pt helvetica`;
      ctx.textAlign = 'center';
      ctx.fillStyle = 'black';
      ctx.fillText("This game will be better enjoyed if you read the",
        this.width * 0.85 + 3,this.height * 0.15);
      ctx.fillText("full instructions. Click 'got it!' when ready.",
        this.width * 0.85 + 3,this.height * 0.2);

      ctx.beginPath();
      ctx.rect(this.width * 0.8, this.height * 0.3, this.width * 0.1, this.height * 0.1);
      ctx.fillStyle = "darkgrey";
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.stroke();
      ctx.fill();

      ctx.fillStyle = 'black';
      ctx.fillText("Full instructions",
        this.width * 0.85,this.height * 0.36);

      //start button
      ctx.beginPath();
      ctx.rect(this.width * 0.8, this.height * 0.8, this.width * 0.1, this.height * 0.1);
      ctx.fillStyle = "limegreen";
      ctx.stroke();
      ctx.fill();

      ctx.font = `${this.height * 0.015 + 4}pt helvetica`;
      ctx.textAlign = 'center';
      ctx.fillStyle = 'black';
      ctx.fillText("Got it!", this.width * 0.85,this.height * 0.86);

      //footer
      ctx.font = `${this.height * 0.008 + 3}pt helvetica`;
      ctx.textAlign = 'center';
      ctx.fillStyle = 'black';
      ctx.fillText("Shapes of War - Designed and coded by Robert Taussig.", this.width * 0.85 + 3,this.height * 0.95);
      ctx.fillText("I sincerely hope you enjoy the game.", this.width * 0.85 + 3,this.height * 0.975);
    } else if (this.stage === "pickCountry") {
      let firstLines = Utils.fragmentText(this.messages[0],
        this.width * 0.31 - parseInt(this.height * 0.018,0), ctx);

      let secondLines = Utils.fragmentText(this.messages[1],
        this.width * 0.31 - parseInt(this.height * 0.018,0), ctx);

      ctx.font = `${this.height * 0.012 + 5}pt helvetica`;
      ctx.textAlign = 'center';
      ctx.fillStyle = '#3e3838';
      firstLines.forEach((line, i) => {
        ctx.fillText(line, this.width * 0.85, (i + 1) *
        parseInt(this.height * 0.025 + 5,0) + this.height * 0.15);
      });

      secondLines.forEach((line, i) => {
        ctx.fillText(line, this.width * 0.85, (i + 1) *
        parseInt(this.height * 0.025 + 5,0) + this.height * 0.5);
      });
    } else if (this.stage === "endGame") {
      let firstLines = Utils.fragmentText(this.messages[2],
        this.width * 0.28 - parseInt(this.height * 0.018,0), ctx);

      let secondLines = Utils.fragmentText(this.messages[3],
        this.width * 0.28 - parseInt(this.height * 0.018,0), ctx);

      ctx.font = `${this.height * 0.012 + 5}pt helvetica`;
      ctx.textAlign = 'center';
      ctx.fillStyle = '#3e3838';
      firstLines.forEach((line, i) => {
        ctx.fillText(line, this.width * 0.85, (i + 1) *
        parseInt(this.height * 0.025 + 5,0) + this.height * 0.15);
      });

      secondLines.forEach((line, i) => {
        ctx.fillText(line, this.width * 0.85, (i + 1) *
        parseInt(this.height * 0.025 + 5,0) + this.height * 0.55);
      });
    } else if (this.game.currentAge > 0){
      // Military Move
      ctx.beginPath();
      ctx.rect(this.width * 0.85 + 2, this.height / 6, this.width * 0.15 - 2, this.height * 0.3);
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.stroke();
      ctx.fillStyle = "white";
      ctx.fill();

    //Military Text
      //Title
      ctx.font = `${this.height * 0.015}pt helvetica`;
      ctx.textAlign = 'center';
      ctx.fillStyle = "black";
      ctx.fillText("Military Goals", this.width * 0.925, this.height / 6 - this.height * 0.015);
      //Option1
      ctx.fillStyle = `${(this.selected === "military-1") ? 'green' : this.unselectedColor}`;
      ctx.fillText(this.milText[0], this.width * 0.925, this.height / 6 + this.height * 0.03);
      //Option2
      ctx.fillStyle = `${(this.selected === "military-2") ? 'green' : this.unselectedColor}`;
      ctx.fillText(this.milText[1], this.width * 0.925, this.height / 6 + this.height * 0.1);
      //Option3
      ctx.fillStyle = `${(this.selected === "military-3") ? 'green' : this.unselectedColor}`;
      ctx.fillText(this.milText[2], this.width * 0.925, this.height / 6 + this.height * 0.17);
      //Option4
      ctx.fillStyle = `${(this.selected === "military-4") ? 'green' : this.unselectedColor}`;
      ctx.fillText(this.milText[3], this.width * 0.925, this.height / 6 + this.height * 0.24);

      // Domestic Move
      ctx.beginPath();
      ctx.rect(this.width * 0.70, this.height / 6, this.width * 0.15, this.height * 0.3);
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.stroke();
      ctx.fillStyle = "white";
      ctx.fill();

    //Domestic Text
      //Title
      ctx.font = `${this.height * 0.015}pt helvetica`;
      ctx.textAlign = 'center';
      ctx.fillStyle = "black";
      ctx.fillText("Domestic Goals", this.width * 0.775, this.height / 6 - this.height * 0.015);
      //Option1
      ctx.fillStyle = `${(this.selected === "domestic-1") ? 'green' : this.unselectedColor}`;
      ctx.fillText(this.domText[0], this.width * 0.775, this.height / 6 + this.height * 0.03);
      //Option2
      ctx.fillStyle = `${(this.selected === "domestic-2") ? 'green' : this.unselectedColor}`;
      ctx.fillText(this.domText[1], this.width * 0.775, this.height / 6 + this.height * 0.1);
      //Option3
      ctx.fillStyle = `${(this.selected === "domestic-3") ? 'green' : this.unselectedColor}`;
      ctx.fillText(this.domText[2], this.width * 0.775, this.height / 6 + this.height * 0.17);
      //Option4
      ctx.fillStyle = `${(this.selected === "domestic-4") ? 'green' : this.unselectedColor}`;
      ctx.fillText(this.domText[3], this.width * 0.775, this.height / 6 + this.height * 0.24);

      //Request Council
      ctx.beginPath();
      ctx.rect(this.width * 0.70, this.height *0.5, this.width * 0.30, this.height * 0.07);
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.stroke();
      ctx.fillStyle = this.game.activeGame ? "limegreen" : "gold";
      ctx.fill();
      //Request text
      ctx.font = `${this.height * 0.02}pt helvetica`;
      ctx.textAlign = 'center';
      ctx.fillStyle = this.game.activeGame ? "white" : "grey";
      ctx.fillText("Hold council", this.width * 0.85, this.height * 0.545);

      // Technology Move
      ctx.beginPath();
      ctx.rect(this.width * 0.70, this.height / 6 + this.height * 0.45, this.width * 0.15, this.height * 0.3);
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.stroke();
      ctx.fillStyle = "white";
      ctx.fill();

    //Technology Text
      //Title
      ctx.font = `${this.height * 0.015}pt helvetica`;
      ctx.textAlign = 'center';
      ctx.fillStyle = "black";
      ctx.fillText("Technology Goals", this.width * 0.775, this.height / 6 + this.height * 0.45 - this.height * 0.015);
      //Option1
      ctx.fillStyle = `${(this.selected === "technology-1") ? 'green' : this.unselectedColor}`;
      ctx.fillText(this.techText[0], this.width * 0.775, this.height / 6 + this.height * 0.48);
      //Option2
      ctx.fillStyle = `${(this.selected === "technology-2") ? 'green' : this.unselectedColor}`;
      ctx.fillText(this.techText[1], this.width * 0.775, this.height / 6 + this.height * 0.55);
      //Option3
      ctx.fillStyle = `${(this.selected === "technology-3") ? 'green' : this.unselectedColor}`;
      ctx.fillText(this.techText[2], this.width * 0.775, this.height / 6 + this.height * 0.62);
      //Option4
      ctx.fillStyle = `${(this.selected === "technology-4") ? 'green' : this.unselectedColor}`;
      ctx.fillText(this.techText[3], this.width * 0.775, this.height / 6 + this.height * 0.69);

      // Shady Move
      ctx.beginPath();
      ctx.rect(this.width * 0.85 + 2, this.height / 6 + this.height * 0.45, this.width * 0.15 - 2, this.height * 0.3);
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.stroke();
      ctx.fillStyle = "white";
      ctx.fill();
    //Shady Text
      //Title
      ctx.font = `${this.height * 0.015}pt helvetica`;
      ctx.textAlign = 'center';
      ctx.fillStyle = "black";
      ctx.fillText("Espionage", this.width * 0.925, this.height / 6 + this.height * 0.45 - this.height * 0.015);
      //Option1
      ctx.fillStyle = `${(this.selected === "shady-1") ? 'green' : this.unselectedColor}`;
      ctx.fillText(this.shadyText[0], this.width * 0.925, this.height / 6 + this.height * 0.48);
      //Option2
      ctx.fillStyle = `${(this.selected === "shady-2") ? 'green' : this.unselectedColor}`;
      ctx.fillText(this.shadyText[1], this.width * 0.925, this.height / 6 + this.height * 0.55);
      //Option3
      ctx.fillStyle = `${(this.selected === "shady-3") ? 'green' : this.unselectedColor}`;
      ctx.fillText(this.shadyText[2], this.width * 0.925, this.height / 6 + this.height * 0.62);
      //Option4
      ctx.fillStyle = `${(this.selected === "shady-4") ? 'green' : this.unselectedColor}`;
      ctx.fillText(this.shadyText[3], this.width * 0.925, this.height / 6 + this.height * 0.69);

      //submit command button

      ctx.beginPath();
      ctx.rect(this.width * 0.81,this.height * 0.928, this.width * 0.08, this.height * 0.06);
      ctx.fillStyle = this.game.activeGame || this.council ? 'gold' : 'limegreen';
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.stroke();
      ctx.fill();

      if (this.game.activeGame) {
        ctx.font = `${this.height * 0.0125 + 5}pt helvetica`;
        ctx.textAlign = 'center';
        ctx.fillStyle = this.game.actionDecided ?
          'black' : 'grey';
        ctx.fillText("End turn", this.width * 0.85 + 3,this.height * 0.965);
      } else {
        ctx.font = `${this.height * 0.0125 + 5}pt helvetica`;
        ctx.textAlign = 'center';
        ctx.fillStyle = this.game.modIsReady &&
          this.selected !== "" &&
          !this.game.activeGame &&
          !this.council ?
          'black' : 'grey';
        ctx.fillText("Make it so!", this.width * 0.85 + 3,this.height * 0.965);
      }
    }

    // Header
    ctx.beginPath();
    ctx.rect(0, 0, this.width, this.height / 10);
    ctx.fillStyle = this.color;
    ctx.lineWidth = 5;
    ctx.strokeStyle = 'black';
    ctx.stroke();
    ctx.fill();

    ctx.font = `${this.height * 0.008 + 3}pt helvetica`;
    ctx.textAlign = 'center';
    ctx.fillStyle = 'black';

    ctx.beginPath();
    ctx.rect(0.02 * this.width, 0.03 * this.height, this.width * 0.06, this.height * 0.04);
    ctx.fillStyle = this.game.sound ? "white" : "darkgrey";
    ctx.stroke();
    ctx.fill();
    ctx.fillStyle = "black";
    ctx.fillText("Toggle sound", this.width * 0.05, this.height * 0.055);

    //info
    ctx.textAlign = 'right';
    ctx.fillText("Domestic Tech:", this.width * 0.62, this.height * 0.025);

    ctx.fillText("Military Tech:", this.width * 0.62, this.height * 0.055);

    ctx.fillText("Soldiers:", this.width * 0.62, this.height * 0.085);

    ctx.fillText("Shady Tech:", this.width * 0.70, this.height * 0.025);

    ctx.fillText("Tech Level:", this.width * 0.70, this.height * 0.055);

    ctx.fillText("Workers:", this.width * 0.70, this.height * 0.085);

    ctx.fillText("Age Progress:", this.width * 0.78, this.height * 0.025);

    ctx.fillText("Disease Level:", this.width * 0.78, this.height * 0.055);

    ctx.fillText("Educators:", this.width * 0.78, this.height * 0.085);

    ctx.fillText("Morale:", this.width * 0.88, this.height * 0.025);

    ctx.fillText("Current Modifier:", this.width * 0.88, this.height * 0.055);

    ctx.fillText("Educator Bonus:", this.width * 0.88, this.height * 0.085);

    //Attributes

    ctx.textAlign = 'left';

    ctx.fillStyle = 'white';

    if (this.game.humanPlayer.country) {
      let country = this.game.humanPlayer.country.object;

      ctx.fillText(Math.round(country.domesticTech * 100) / 100,
       this.width * 0.625, this.height * 0.025);

      ctx.fillText(Math.round(country.militaryTech * 100) / 100,
      this.width * 0.625, this.height * 0.055);

      ctx.fillText(Math.round(country.soldiers * 100) / 100,
      this.width * 0.625, this.height * 0.085);

      ctx.fillText(Math.round(country.shadyTech * 100) / 100,
        this.width * 0.705, this.height * 0.025);

      ctx.fillText(Math.round(country.techPower * 100) / 100,
        this.width * 0.705, this.height * 0.055);

      ctx.fillText(Math.round(country.workers * 100) / 100,
        this.width * 0.705, this.height * 0.085);

      let numerator = Math.round(Math.min(country.ageProgress, 1000) * 100) / 100;
      let denominator = numerator < 10 ? 10 : (numerator < 100 ? 100 : 1000);

      ctx.fillText(`${numerator}/${denominator}`,
        this.width * 0.785, this.height * 0.025);

      ctx.fillText(Math.round(country.diseaseRate * 100) / 100,
        this.width * 0.785, this.height * 0.055);

      ctx.fillText(Math.round(country.educators * 100) / 100,
        this.width * 0.785, this.height * 0.085);

      ctx.fillText(Math.round(country.morale * 100) / 100,
        this.width * 0.885, this.height * 0.025);

      let mod;
      let currentMod = this.game.humanPlayer.modifier;
      let modPrefix = currentMod.split('-')[0];
      let modNum = parseInt(currentMod.split('-')[1]) - 1;
      if (modPrefix === "technology") {
        mod = this.techText[modNum];
      } else if (modPrefix === "domestic") {
        mod = this.domText[modNum];
      } else if (modPrefix === "military") {
        mod = this.milText[modNum];
      } else if (modPrefix === "shady") {
        mod = this.shadyText[modNum];
      } else if (modPrefix === "") {
        mod = "Not picked";
      }

      ctx.fillText(mod,
        this.width * 0.885, this.height * 0.055);

      ctx.fillText(Math.round(country.educatorBonus * 100) / 100,
        this.width * 0.885, this.height * 0.085);
    } else {
      ctx.fillText(0,
       this.width * 0.625, this.height * 0.025);

      ctx.fillText(0, this.width * 0.625, this.height * 0.055);

      ctx.fillText(0, this.width * 0.625, this.height * 0.085);

      ctx.fillText(0, this.width * 0.705, this.height * 0.025);

      ctx.fillText(0, this.width * 0.705, this.height * 0.055);

      ctx.fillText(0, this.width * 0.705, this.height * 0.085);

      ctx.fillText("0/100", this.width * 0.785, this.height * 0.025);

      ctx.fillText(0, this.width * 0.785, this.height * 0.055);

      ctx.fillText(0, this.width * 0.785, this.height * 0.085);

      ctx.fillText(0, this.width * 0.885, this.height * 0.025);

      ctx.fillText(0, this.width * 0.885, this.height * 0.055);

      ctx.fillText(0, this.width * 0.885, this.height * 0.085);
    }






    // for testing

    // ctx.fillText("For testing only", this.width * 0.03, this.height * 0.055);
    //
    // ctx.fillText("start game", this.width * 0.10, this.height * 0.055);
    //
    // ctx.fillText("instructions", this.width * 0.15, this.height * 0.055);
    //
    // ctx.fillText("make decision", this.width * 0.2, this.height * 0.055);
    //
    // ctx.fillText("between ages", this.width * 0.26, this.height * 0.055);
    //
    // ctx.fillText("resume game", this.width * 0.33, this.height * 0.055);

    // Header Text

    ctx.font = `${this.height * 0.025}pt helvetica`;
    ctx.textAlign = 'center';
    ctx.fillStyle = 'black';
    ctx.fillText(this.message, this.width * 0.5, this.height * 0.06);
  }
}



module.exports = Interface;



/*****************
 ** WEBPACK FOOTER
 ** ./game/views/interface.js
 ** module id = 3
 ** module chunks = 0
 **/